import { c as _c } from "react/compiler-runtime";
import { ChildrenProps } from 'shared/ui/uiType';
import { QuestionCfg } from 'shared/forecast/question';
import { Forecast as F } from 'shared/forecast/forecast';
import { keys } from 'shared/collection';
import { Mention } from 'shared/ui';
import { useContext, useMemo, useRef, useState } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from '@ag-grid-community/react';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping';
import { MentionContext } from 'components/form/lexical/MentionNode';
import { ProfileUI } from 'components/portal/profileTypes';
import { usePortal } from 'components/portal/portal';
import { SAvatar } from 'components/portal/SAvatar';
import { HiCheck, HiSortAscending, HiSortDescending } from 'react-icons/hi';
import { HiChatBubbleLeft } from 'react-icons/hi2';
import ReactDOMServer from 'react-dom/server';
import { Badge, Button, ButtonProps, Checkbox, Chip, MenuItemProps, TextInput, Tooltip } from '@mantine/core';
import { ColDef, RowNode } from 'ag-grid-community';
import { P, match } from 'ts-pattern';
import { DateTime } from 'luxon';
import { RichText } from 'components/form/RichText';
import { useForm } from '@mantine/form';
import { okOrShowError, showError } from 'components/notify';
import { showNotification } from '@mantine/notifications';
import { ButtonSplit } from 'components/Buttons';
import { mapValues, pipe, sortBy } from 'remeda';
import { ForecastStatusAction, ForecastStatus } from 'shared/forecast/forecastTypes';
import { fmtDate } from 'shared/format';
import styles from './ForecastTable.module.css';
import { SubqTypeIcon } from './Subqs';
import { sb } from 'utils/db';
import { compactString } from 'shared/text';
import { Notify } from 'api/notify';
import { useQuestionQuery } from './useQuestions';
import { useForecasts } from './useForecasts';
import { useSubqQuery } from './subq';
const modules = [ClientSideRowModelModule, RowGroupingModule];
const html = ReactDOMServer.renderToStaticMarkup;
const icons = {
  sortAscending: html(<HiSortAscending />),
  sortDescending: html(<HiSortDescending />)
};
const Cell = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <span className="custom-value">{children}</span>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const CellBy = t0 => {
  const $ = _c(7);
  const {
    value
  } = t0;
  const {
    profiles
  } = useContext(MentionContext);
  let t1;
  if ($[0] !== profiles || $[1] !== value) {
    let t2;
    if ($[3] !== profiles) {
      t2 = v_0 => profiles?.[v_0];
      $[3] = profiles;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = match(value).with({
      id: P.string
    }, _temp).with(P.string, t2).otherwise(_temp2);
    $[0] = profiles;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const profile = t1;
  let t2;
  if ($[5] !== profile) {
    t2 = <Cell>{profile ? <SAvatar size="sm" profile={profile} className="flex text-center" /> : <></>}</Cell>;
    $[5] = profile;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
const CellTitle = t0 => {
  const $ = _c(5);
  const {
    value,
    data,
    node
  } = t0;
  const type = data ? data.type : node?.allLeafChildren[0]?.data?.type;
  let t1;
  if ($[0] !== type) {
    t1 = type == "cause" || type == "consequence" ? <SubqTypeIcon type={type} /> : <></>;
    $[0] = type;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1 || $[3] !== value) {
    t2 = <Cell>{t1}{value}</Cell>;
    $[2] = t1;
    $[3] = value;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
const CellForecast = t0 => {
  const $ = _c(3);
  const {
    data
  } = t0;
  if (!data) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <></>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const {
    forecastValueLabel
  } = data;
  const t1 = forecastValueLabel != undefined ? forecastValueLabel : "";
  let t2;
  if ($[1] !== t1) {
    t2 = <Cell>{t1}</Cell>;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
const CellComment = t0 => {
  const $ = _c(6);
  const {
    data
  } = t0;
  if (!data?.note) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <></>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== data.note) {
    t1 = <div className="max-w-[40em]"><RichText readonly={true} value={data.note} /></div>;
    $[1] = data.note;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span><HiChatBubbleLeft color="var(--mantine-color-gray-3)" size={20} /></span>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = <Cell><Tooltip withinPortal={true} label={t1}>{t2}</Tooltip></Cell>;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
type ForecastRow = {
  forecastValue: number | undefined;
  forecastValueLabel: string | undefined;
  note: string | undefined;
  at: string;
  by: ProfileUI | undefined;
  type: string;
  title: string;
  id: string;
  statuses: ForecastStatus[];
};
type GroupColName = 'type' | 'title' | 'by' | 'none';
export const ForecastTable = ({
  question_id
}: {
  question_id: string;
}) => {
  const {
    data: row
  } = useQuestionQuery({
    question_id
  });
  const questionCfg = row?.ok ? row.cfg : undefined;
  const {
    getForecasts
  } = useForecasts({
    filter: {
      question_id
    },
    disabled: questionCfg == null
  });
  const {
    data: subqs
  } = useSubqQuery({
    question_id,
    status: ['approved']
  });
  const {
    profiles
  } = useContext(MentionContext);
  const [groupCol, setGroupCol] = useState<GroupColName>('none');
  const gridRef = useRef<AgGridReact>(null);
  const question = row?.ok ? {
    id: row.id,
    ...row.cfg
  } as QuestionCfg & {
    id: string;
  } : undefined;
  const rows = useMemo(() => {
    if (!question) return;
    const questionRes = F.getQuestionResolutionForecast({
      question,
      getForecasts
    });
    const qRows = questionRes?.forecasts.map(f => ({
      type: 'question',
      title: question?.title ?? '',
      forecast: f,
      resolution: undefined,
      fmt: questionRes.fmt
    })) ?? [];
    const sqRows = subqs?.flatMap(s => F.getResolutionForecasts({
      question,
      subq: s.cfg,
      getForecasts,
      sqId: s.id
    }).filter(f_0 => f_0.forecasts.length).flatMap(rf => rf.forecasts.map(f_1 => ({
      type: s.cfg.subquestionType,
      title: `${s.cfg.title}`,
      resolution: compactString(rf.resolution.labelShort) ?? rf.resolution.label,
      forecast: f_1,
      fmt: rf.fmt
    })))) ?? [];
    return pipe([...qRows, ...sqRows].map(({
      forecast: f_2,
      ...r
    }) => ({
      id: f_2.id,
      ...r,
      forecastValue: f_2.value,
      forecastValueLabel: r.fmt(f_2.value),
      note: f_2.cfg.notes,
      at: f_2.created_at!,
      by: profiles?.[f_2.created_by!],
      statuses: keys(f_2.cfg.status)
    })), sortBy([r_0 => r_0.at, 'desc']));
  }, [question, getForecasts, subqs]);
  type Col = ColDef<ForecastRow>;
  const colDefs: Col[] = useMemo(() => ([{
    headerName: '',
    field: 'by',
    cellRenderer: CellBy,
    // cellStyle: {backgroundColor: '--mantine-color-gray-1'},
    width: 100,
    valueFormatter: ({
      value
    }: {
      value: ProfileUI;
    }) => value ? value.name : '',
    keyCreator: ({
      value: value_0
    }: {
      value: ProfileUI;
    }) => value_0 ? value_0.id : '',
    checkboxSelection: groupCol == 'none',
    headerCheckboxSelection: groupCol == 'none'
  }, {
    headerName: 'Title',
    field: 'title',
    flex: 1,
    sortable: true,
    enableRowGroup: true,
    cellRenderer: CellTitle
  }, {
    headerName: 'Resolution',
    field: 'resolution',
    sortable: true,
    filter: true,
    width: 120
  }, {
    headerName: 'Status',
    field: 'statuses',
    width: 120
  }, {
    headerName: `At (${DateTime.now().zoneName} time)`,
    field: 'at',
    valueFormatter: ({
      value: d
    }: {
      value: string;
    }) => d ? fmtDate(d, {
      showTime: true
    }) : '',
    cellDataType: 'dateString',
    width: 180
  }, {
    headerName: 'Forecast',
    field: 'forecastValue',
    type: 'numericColumn',
    cellRenderer: CellForecast,
    width: 120
  }, {
    headerName: 'Comment',
    field: 'note',
    cellRenderer: CellComment,
    width: 80
  }] as Col[]).map(c => groupCol && match(groupCol).with('title', () => ['title', 'resolution'].includes(c.field!)).otherwise(() => groupCol == c.field) ? {
    ...c,
    rowGroup: true,
    hide: true
  } : {
    ...c,
    rowGroup: false,
    hide: false
  }), [groupCol]);
  const autoGroupColumnDef = useMemo(() => ({
    headerName: colDefs.find(c_0 => c_0.field == groupCol)?.headerName ?? 'Group',
    width: match(groupCol).with('by', () => 140).with('title', () => 600).otherwise(() => 200),
    checkboxSelection: true
  }), [groupCol]);
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const selected = useMemo(() => selectedIds.map(id => rows?.find(r_1 => r_1.id == id)!).filter(r_2 => r_2), [selectedIds, rows]);
  return <div className={styles.root}>
      <div className='flex justify-between items-end'>
        <div className='flex gap-2'>
          <Chip.Group multiple={false} value={groupCol} onChange={v => setGroupCol(v as GroupColName)}>
            <Chip value='none'>all</Chip>
            <Chip value='title'>by forecast</Chip>
            <Chip value='by'>by user</Chip>
          </Chip.Group>
        </div>
        <div className='flex gap-2'>{question && <ForecastMenu selected={selected} question={question} />}</div>
      </div>

      {rows && <AgGridReact<ForecastRow> ref={gridRef} modules={modules} rowData={rows} getRowId={r_3 => r_3.data.id} autoGroupColumnDef={autoGroupColumnDef} defaultColDef={{
      resizable: true,
      sortable: true,
      filter: true,
      floatingFilter: false
    }} columnDefs={colDefs as any} icons={icons} domLayout='autoHeight' className='ag-theme-swift ag-theme-alpine mt-4' rowHeight={35} rowSelection='multiple' groupSelectsChildren onSelectionChanged={() => {
      setSelectedIds(gridRef.current?.api.getSelectedRows().map(r_4 => r_4.id) ?? []);
    }} onGridReady={() => {
      const api = gridRef.current?.api;
      if (!api) return;
      const state = api.getColumnState();
      const hasSort = state.some(s_0 => s_0.sort);
      if (hasSort) return;
      api.applyColumnState({
        state: [{
          colId: 'at',
          sort: 'desc'
        }]
      });
    }} />}
    </div>;
};
const statusMd = {
  expired: {
    verb: 'Expire',
    desc: 'Expire a forecast when it needs updating to remain relevant (e.g. world changes mean you only want results re-forecast after this point). It will only be included when viewing results "as of" time before expiration.',
    color: 'orange'
  },
  excluded: {
    verb: 'Exclude',
    desc: 'Exclude a forecast when you want to remove it from results permanently (e.g. question changed or forecast made in error)',
    color: 'red'
  },
  restored: {
    verb: 'Restore',
    desc: 'Restore an expired or excluded forecast to include it in results again',
    color: 'green'
  }
} as const;
type ForecastMenuProps = {
  selected: ForecastRow[];
  question: {
    id: string;
    title: string;
  };
};
const ForecastMenu = ({
  selected: selectedRaw,
  question
}: ForecastMenuProps) => {
  const {
    profile
  } = usePortal();
  const [action, setAction] = useState<ForecastStatusAction>('expired');
  const [show, setShow] = useState(false);
  const getSelected = (a: ForecastStatusAction) => selectedRaw.filter(f => a == 'restored' ? f.statuses.length > 0 : !f.statuses.includes(a));
  const selected = getSelected(action ?? 'expired');
  return <div>
      {show ? <ForecastStatusPop {...{
      action: action,
      question,
      selected
    }} onCanceled={() => setShow(false)} onConfirmed={async ({
      action: action_0,
      msg,
      subject,
      notify
    }) => {
      const by = profile?.id;
      if (!by) return;
      const ids = selected.map(s => s.id);
      match(await sb.rpc('update_cfgs', {
        table_name: 'forecast',
        ids,
        cfg_updates: action_0 == 'restored' ? {
          status: {}
        } : {
          [`status.${action_0}`]: {
            at: DateTime.now().toISO(),
            by
          }
        },
        profile_id: by,
        updated_at: DateTime.now().toISO()!
      })).with({
        error: P.not(P.nullish).select()
      }, e => showError(e.message, 'Error updating forecasts')).otherwise(d => {
        if (notify) Notify.onQuestionChange({
          part: 'forecast-status',
          question_id: question.id,
          action: action_0,
          ids,
          msg,
          subject
        }).then(okOrShowError);
        showNotification({
          message: `Updated ${selected.length} forecasts`
        });
        setShow(false);
      });
    }} /> : <ButtonSplit<ForecastStatusAction> value={action} showSelected items={mapValues(statusMd, ({
      verb,
      desc
    }, a_0) => {
      const selected_0 = getSelected(a_0);
      return {
        children: <div>
                  <div className='font-semibold flex items-center gap-2'>
                    {a_0 == action && <HiCheck />}
                    {verb}
                    <Badge size='sm' color={statusMd[a_0].color}>
                      {selected_0.length}
                    </Badge>
                  </div>
                  <div className='text-sm opacity-50 max-w-[30em]'>{desc}</div>
                </div>,
        disabled: selected_0.length == 0
      } as MenuItemProps;
    })} onChange={a_1 => setAction(a_1)} button={a_2 => {
      const selected_1 = getSelected(a_2);
      return {
        children: <div className='font-semibold flex items-center gap-2'>
                  {statusMd[a_2].verb}{' '}
                  <Badge size='sm' color='gray'>
                    {selected_1.length}
                  </Badge>
                </div>,
        disabled: selected_1.length == 0,
        color: statusMd[a_2].color
      } as ButtonProps;
    }} onClick={a_3 => setShow(true)} />}
    </div>;
};
type ForecastStatusPopProps = {
  action: ForecastStatusAction;
  onCanceled: () => void;
  onConfirmed: (p: StatusActionConfirmed) => Promise<void>;
} & Pick<ForecastMenuProps, 'selected' | 'question'>;
type StatusActionConfirmed = {
  action: ForecastStatusAction;
  notify: boolean;
  msg: string;
  subject: string;
} & Pick<ForecastMenuProps, 'selected'>;
const ForecastStatusPop = t0 => {
  const $ = _c(57);
  const {
    action,
    selected,
    onCanceled,
    onConfirmed,
    question: q
  } = t0;
  const n = selected.length;
  const {
    verb
  } = statusMd[action];
  let t1;
  if ($[0] !== q.id || $[1] !== q.title) {
    t1 = Mention.markdown({
      type: "question",
      title: q.title,
      path: q.id
    });
    $[0] = q.id;
    $[1] = q.title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const questionA = t1;
  let t2;
  if ($[3] !== action || $[4] !== questionA) {
    let t3;
    if ($[6] !== questionA) {
      t3 = () => `The following forecasts in ${questionA} will no longer be included in the aggregated results:`;
      $[6] = questionA;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    let t4;
    if ($[8] !== questionA) {
      t4 = () => `These forecasts in ${questionA} have been marked as expired and will need to be updated:`;
      $[8] = questionA;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    let t5;
    if ($[10] !== questionA) {
      t5 = () => `These forecasts in ${questionA} have been restored and will be included in the aggregated results:`;
      $[10] = questionA;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    t2 = match(action).with("excluded", t3).with("expired", t4).with("restored", t5).exhaustive();
    $[3] = action;
    $[4] = questionA;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[12] !== t2) {
    t3 = {
      initialValues: {
        notify: true,
        msg: t2,
        subject: "Forecast housekeeping"
      }
    };
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  const {
    values,
    getInputProps: inProps
  } = useForm(t3);
  const {
    notify
  } = values;
  let t4;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      loading: false,
      disabled: false
    };
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const [buttonState, setButtonState] = useState(t4);
  let t5;
  if ($[15] !== inProps) {
    t5 = inProps("subject");
    $[15] = inProps;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  const t6 = !notify;
  let t7;
  if ($[17] !== t5 || $[18] !== t6) {
    t7 = <TextInput variant="title" placeholder="Subject" {...t5} disabled={t6} />;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== inProps) {
    t8 = inProps("msg");
    $[20] = inProps;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  const t9 = !notify;
  let t10;
  if ($[22] !== t8 || $[23] !== t9) {
    t10 = <RichText {...t8} disabled={t9} />;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t7) {
    t11 = <div className="space-y-2">{t7}{t10}</div>;
    $[25] = t10;
    $[26] = t7;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== n || $[29] !== verb) {
    t12 = <span>{verb} the {n} selected forecasts.</span>;
    $[28] = n;
    $[29] = verb;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== action || $[32] !== onConfirmed || $[33] !== selected || $[34] !== values) {
    t13 = () => {
      setButtonState({
        loading: true,
        disabled: true
      });
      onConfirmed({
        action,
        selected,
        ...values
      }).finally(() => setButtonState({
        loading: false,
        disabled: false
      }));
    };
    $[31] = action;
    $[32] = onConfirmed;
    $[33] = selected;
    $[34] = values;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  let t14;
  if ($[36] !== buttonState || $[37] !== n || $[38] !== t13 || $[39] !== verb) {
    t14 = <Button {...buttonState} variant="filled" onClick={t13}>Confirm {verb} ({n})</Button>;
    $[36] = buttonState;
    $[37] = n;
    $[38] = t13;
    $[39] = verb;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  let t15;
  if ($[41] !== t12 || $[42] !== t14) {
    t15 = <Tooltip label={t12}>{t14}</Tooltip>;
    $[41] = t12;
    $[42] = t14;
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  let t16;
  if ($[44] !== onCanceled) {
    t16 = <Button variant="outline" onClick={() => onCanceled()}>Cancel</Button>;
    $[44] = onCanceled;
    $[45] = t16;
  } else {
    t16 = $[45];
  }
  let t17;
  if ($[46] !== inProps) {
    t17 = inProps("notify", {
      type: "checkbox"
    });
    $[46] = inProps;
    $[47] = t17;
  } else {
    t17 = $[47];
  }
  let t18;
  if ($[48] !== t17) {
    t18 = <Checkbox label="notify impacted users" className="my-2" {...t17} />;
    $[48] = t17;
    $[49] = t18;
  } else {
    t18 = $[49];
  }
  let t19;
  if ($[50] !== t15 || $[51] !== t16 || $[52] !== t18) {
    t19 = <div className="w-full mt-4 pr-2 flex gap-4 flex-row-reverse">{t15}{t16}{t18}</div>;
    $[50] = t15;
    $[51] = t16;
    $[52] = t18;
    $[53] = t19;
  } else {
    t19 = $[53];
  }
  let t20;
  if ($[54] !== t11 || $[55] !== t19) {
    t20 = <div className="flex flex-col gap-2 w-[40em]">{t11}{t19}</div>;
    $[54] = t11;
    $[55] = t19;
    $[56] = t20;
  } else {
    t20 = $[56];
  }
  return t20;
};
function _temp(v) {
  return v;
}
function _temp2() {}